/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller } from "react-hook-form";
import {
  Button,
  TextField,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  Paper,
  Tab,
  Box,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { withStyles } from "@mui/styles";

//Icons
import SaveIcon from "@mui/icons-material/Save";
import FeatherIcon from "feather-icons-react";

//Actions
import ShowNotification from "../../../../../utils/redux/actions/global/notifications/NotificationAction";
import AdicionarUtilizador from "../../../../../utils/redux/actions/utilizadores/adicionarUtilizadorActions";
import GetPermissoesPerfil from "../../../../../utils/redux/actions/utilizadores/GetPermissoesPerfilAction";
import GetDepartamentos from "../../../../../utils/redux/actions/utilizadores/GetDepartamentosAction";

//Components
import Spinner from "../../../../../Global/Components/Spinner";
import { TabContext, TabList, TabPanel } from "@mui/lab";

const CustomCheckbox = withStyles({
  root: {
    color: "#929CA6",
    "&$checked": {
      color: "#929CA6",
    },
    background: "transparent !important",
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const FormAdd = ({
  toggleDrawer,
  fetchUtilizadores,
  utilizador,
  setUtilizador,
  validationUtilizador,
  utilizadorInfo,
  perfis,
  parceiros,
  diretoresObra,
  validateOnChange = true,
  classes,
  aeroportos,
  guardarLoading,
  setGuardarLoading,
  // React hook form
  control,
  handleSubmitForm,
  errors,
  reset,
  getValues,
  watch,
  setValue,
  trigger,
}) => {
  const dispatch = useDispatch();

  const permissoes = useSelector((state) => state.utilizadores.permissoes);

  const [perfil, setPerfil] = useState(null);

  const handleChangePerfisId = (value) => {
    // e.preventDefault();
    setPerfil(value.id);
    dispatch(GetPermissoesPerfil(value && value.id));
    if (validateOnChange) validationUtilizador({ perfisId: value });
  };

  //DEPARTAMENTOS

  // FETCH DEPARTAMENTOS

  const change = watch("aeroportosDropdown");

  const [old, setOld] = useState(
    utilizadorInfo &&
      utilizadorInfo.aeroportosDropdown &&
      utilizadorInfo.aeroportosDropdown.id
  );
  useEffect(() => {
    const aeroId = change && change.id != null ? change.id : null;

    dispatch(GetDepartamentos(aeroId))
      .then(() => setOld(aeroId))
      .then(() => {
        if (old != null && old !== aeroId) {
          trigger("departamentosDropdown");
          setValue("departamentosDropdown", "");
        }
      });
  }, [change && change.id]);

  const departamentos = useSelector(
    (state) => state.utilizadores.departamentos
  );

  //PERMISSOES

  const handleChangePermissoes = (permissao, grupo) => {
    // seleciona o grupo
    const grupoSelecionado = permissoes.findIndex(
      (g) => g.grupo == grupo.grupo
    );
    // seleciona a permissao
    const permisaoSelecionada =
      grupoSelecionado >= 0 &&
      permissoes[grupoSelecionado].lista.findIndex((p) => p.id == permissao.id);
    // muda o redux
    permissoes[grupoSelecionado].lista[permisaoSelecionada].permissao =
      !permissoes[grupoSelecionado].lista[permisaoSelecionada].permissao;
    dispatch({
      type: "GET_PERMISSOES",
      payload: [...permissoes],
    });
  };

  useEffect(() => {
    setUtilizador({
      nome: "",
      email: "",
      perfisId: "",
      aeroportoId: "",
      aeroportosDropdown: "",
      departamentosId: "",
      departamentosDropdown: "",
      energParceirosId: "",
      perfilDropdown: "",
    });
  }, []);

  useEffect(() => {
    if (utilizadorInfo) {
      reset({
        nome: "",
        email: "",
        aeroportosDropdown: "",
        departamentosDropdown: "",
        perfilDropdown: "",
      });
    }
  }, [utilizadorInfo]);

  const onSubmit = (data) => {
    // e.preventDefault();

    const aeroportosId = () => {
      if (
        // data.aeroportosDropdown === 1 ||
        data.aeroportosDropdown === 0 ||
        data.aeroportosDropdown == null
      ) {
        return null;
      } else {
        return data.aeroportosDropdown.id;
      }
    };

    const ydata = [
      {
        nome: data.nome,
        email: data.email,
        perfilId: data.perfilDropdown && data.perfilDropdown.id,
        aeroportosId: aeroportosId(),
        departamentosId:
          data.departamentosDropdown && data.departamentosDropdown.id !== 0
            ? data.departamentosDropdown.id
            : null,
        energParceirosId: data.parceirosDropdown && data.parceirosDropdown.id,
        diretorId:
          data.diretoresDropdown && data.diretoresDropdown.id !== 0
            ? data.diretoresDropdown.id
            : null,
        permissoes: permissoes
          .map((p) => p.lista)
          .flat()
          .map((permissao) => {
            if (permissao.permissao) {
              return permissao.id;
            }
            return null;
          })
          .filter((permissao) => {
            return permissao != null;
          }),
      },
    ];

    const message = {
      isOpen: true,
      message: "Utilizador adicionado com sucesso!!",
      type: "success",
    };
    const errorMessage = {
      isOpen: true,
      message: "Ocorreu um erro!!",
      type: "error",
    };

    console.log(ydata);

    setGuardarLoading(true);

    dispatch(
      AdicionarUtilizador(
        ydata,
        ShowNotification,
        message,
        errorMessage,
        toggleDrawer
      )
    )
      .then(() => fetchUtilizadores())
      .then(() => setGuardarLoading(false));
  };

  // ############################################################## //
  // ###########################  Tabs  ########################### //
  // ############################################################## //

  const [valueTab, setValueTab] = useState(0);

  const handleChange = (event, newValue) => {
    setValueTab(newValue);
  };

  return (
    <>
      {utilizador ? (
        <div
          style={{
            isplay: "flex",
            flexDirection: "column",
            padding: "40px",
            height: "100%",
          }}
        >
          <form onSubmit={handleSubmitForm(onSubmit)}>
            <div className={classes.drawerHeader}>
              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => toggleDrawer("right", false)}
              >
                <div>
                  <FeatherIcon
                    icon="chevron-left"
                    size={20}
                    style={{ strokeWidth: "1.5" }}
                  />
                </div>
                <div className="text-underline-close-drawer">
                  Lista de Utilizadores
                </div>
              </div>

              {!guardarLoading ? (
                <Button className={classes.btnGuardar} type="submit">
                  Guardar
                </Button>
              ) : (
                <LoadingButton
                  color="secondary"
                  loading={guardarLoading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  type="submit"
                  className={classes.btnGuardar}
                >
                  Guardar
                </LoadingButton>
              )}
            </div>
            <Paper sx={{ px: 6, py: 2, mt: 4 }}>
              <h4
                style={{
                  fontSize: "22px",
                  width: "100%",
                  marginBottom: "0px",
                }}
                className="text-underline"
              >
                Dados do utilizador
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                <h4
                  style={{ color: "#E21450", width: "100%" }}
                  className="text-underline-title-drawer "
                >
                  Informações pessoais
                </h4>
                <Controller
                  name="nome"
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        label="Nome"
                        color="primary"
                        variant="outlined"
                        size="small"
                        {...field}
                        fullWidth
                        style={{ marginTop: "10px", width: "49%" }}
                        error={!!errors.nome}
                        helperText={errors.nome ? errors.nome?.message : ""}
                      />
                    </>
                  )}
                />
                <span style={{ width: "2%" }} />
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        label="Email"
                        color="primary"
                        variant="outlined"
                        size="small"
                        {...field}
                        fullWidth
                        style={{ marginTop: "10px", width: "49%" }}
                        error={!!errors.email}
                        helperText={errors.email ? errors.email?.message : ""}
                      />
                    </>
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                <Controller
                  name="perfilDropdown"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <>
                      <Autocomplete
                        clearText="Limpar"
                        openText="Abrir"
                        closeText="Fechar"
                        noOptionsText="Sem dados"
                        options={perfis || []}
                        value={value || null}
                        getOptionLabel={(option) => `${option.descricao}` || ""}
                        isOptionEqualToValue={(option, value) => {
                          // if (!value.id) return true;
                          return value.id === option.id;
                        }}
                        style={{ marginTop: "10px", width: "49%" }}
                        filterOptions={(options, state) => {
                          let newOptions = [];
                          options.forEach((option) => {
                            if (
                              option.id > 0 &&
                              option.descricao
                                .toLowerCase()
                                .includes(state.inputValue.toLowerCase())
                            )
                              newOptions.push(option);
                          });
                          return newOptions;
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            label="Perfil"
                            placeholder="Perfil"
                            variant="outlined"
                            error={!!errors.perfilDropdown}
                            helperText={
                              errors.perfilDropdown
                                ? errors.perfilDropdown?.message
                                : ""
                            }
                          />
                        )}
                        onChange={(_, value) => {
                          onChange(value);
                          handleChangePerfisId(value);
                          return value;
                        }}
                      />
                    </>
                  )}
                />
                <span style={{ width: "2%" }} />
                {perfil == 5 ? (
                  <Controller
                    name="parceirosDropdown"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <>
                        <Autocomplete
                          fullWidth
                          clearText="Limpar"
                          openText="Abrir"
                          closeText="Fechar"
                          noOptionsText="Sem dados"
                          options={parceiros || []}
                          value={value || null}
                          getOptionLabel={(option) => `${option.nome}` || ""}
                          isOptionEqualToValue={(option, value) => {
                            // if (!value.id) return true;
                            return value.id === option.id;
                          }}
                          style={{ marginTop: "10px", width: "49%" }}
                          filterOptions={(options, state) => {
                            let newOptions = [];
                            options.forEach((option) => {
                              if (
                                option.id > 0 &&
                                option.nome
                                  .toLowerCase()
                                  .includes(state.inputValue.toLowerCase())
                              )
                                newOptions.push(option);
                            });
                            return newOptions;
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Parceiro"
                              placeholder="Parceiro"
                              variant="outlined"
                              error={!!errors.departamentosDropdown}
                              helperText={
                                errors.departamentosDropdown
                                  ? errors.departamentosDropdown?.message
                                  : ""
                              }
                            />
                          )}
                          onChange={(_, value) => {
                            onChange(value);
                            return value;
                          }}
                        />
                      </>
                    )}
                  />
                ) : perfil !== null ? (
                  <>
                    <Controller
                      name="aeroportosDropdown"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <>
                          <Autocomplete
                            fullWidth
                            clearText="Limpar"
                            openText="Abrir"
                            closeText="Fechar"
                            noOptionsText="Sem dados"
                            options={aeroportos || []}
                            value={value || null}
                            getOptionLabel={(option) =>
                              `${option.descricao}` || ""
                            }
                            isOptionEqualToValue={(option, value) => {
                              // if (!value.id) return true;
                              return value.id === option.id;
                            }}
                            style={{
                              marginTop: "10px",
                              width: "23%",
                              marginRight: "2%",
                            }}
                            filterOptions={(options, state) => {
                              let newOptions = [];
                              options.forEach((option) => {
                                if (
                                  option.id > 0 &&
                                  option.descricao
                                    .toLowerCase()
                                    .includes(state.inputValue.toLowerCase())
                                )
                                  newOptions.push(option);
                              });
                              return newOptions;
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Aeroporto"
                                placeholder="Aeroporto"
                                variant="outlined"
                                error={!!errors.aeroportosDropdown}
                                helperText={
                                  errors.aeroportosDropdown
                                    ? errors.aeroportosDropdown?.message
                                    : ""
                                }
                              />
                            )}
                            onChange={(_, value) => {
                              onChange(value);
                              return value;
                            }}
                          />
                        </>
                      )}
                    />
                    <Controller
                      name="departamentosDropdown"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <>
                          <Autocomplete
                            fullWidth
                            clearText="Limpar"
                            openText="Abrir"
                            closeText="Fechar"
                            noOptionsText="Sem dados"
                            options={departamentos || []}
                            value={value || null}
                            getOptionLabel={(option) =>
                              `${option.descricao}` || ""
                            }
                            isOptionEqualToValue={(option, value) => {
                              // if (!value.id) return true;
                              return value.id === option.id;
                            }}
                            style={{ marginTop: "10px", width: "24%" }}
                            filterOptions={(options, state) => {
                              let newOptions = [];
                              options.forEach((option) => {
                                if (
                                  option.id > 0 &&
                                  option.descricao
                                    .toLowerCase()
                                    .includes(state.inputValue.toLowerCase())
                                )
                                  newOptions.push(option);
                              });
                              return newOptions;
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Departamento"
                                placeholder="Departamento"
                                variant="outlined"
                                error={!!errors.departamentosDropdown}
                                helperText={
                                  errors.departamentosDropdown
                                    ? errors.departamentosDropdown?.message
                                    : ""
                                }
                              />
                            )}
                            onChange={(_, value) => {
                              onChange(value);
                              return value;
                            }}
                          />
                        </>
                      )}
                    />
                  </>
                ) : null}
                {perfil == 3 && (
                  <Controller
                    name="diretoresDropdown"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <>
                        <Autocomplete
                          fullWidth
                          clearText="Limpar"
                          openText="Abrir"
                          closeText="Fechar"
                          noOptionsText="Sem dados"
                          options={diretoresObra || []}
                          value={value || null}
                          getOptionLabel={(option) => `${option.nome}` || ""}
                          isOptionEqualToValue={(option, value) => {
                            // if (!value.id) return true;
                            return value.id === option.id;
                          }}
                          style={{ marginTop: "10px", width: "49%" }}
                          filterOptions={(options, state) => {
                            let newOptions = [];
                            options.forEach((option) => {
                              if (
                                option.id > 0 &&
                                option.nome
                                  .toLowerCase()
                                  .includes(state.inputValue.toLowerCase())
                              )
                                newOptions.push(option);
                            });
                            return newOptions;
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Diretor de obra"
                              placeholder="Diretor de obra"
                              variant="outlined"
                              error={!!errors.diretoresDropdown}
                              helperText={
                                errors.diretoresDropdown
                                  ? errors.diretoresDropdown?.message
                                  : ""
                              }
                            />
                          )}
                          onChange={(_, value) => {
                            onChange(value);
                            return value;
                          }}
                        />
                      </>
                    )}
                  />
                )}
              </div>

              <h4
                style={{ color: "#E21450" }}
                className="text-underline-title-drawer "
              >
                Permissões
              </h4>
              <TabContext value={valueTab}>
                <>
                  <Box>
                    <TabList
                      onChange={handleChange}
                      aria-label="lab API tabs example"
                      variant="scrollable"
                    >
                      {permissoes &&
                        permissoes.map((permissao, index) => (
                          <Tab
                            label={permissao.grupo}
                            value={index}
                            className={classes.tab}
                          />
                        ))}
                    </TabList>
                  </Box>

                  {permissoes &&
                    permissoes.map((permissao, index) => (
                      <TabPanel value={index}>
                        <div
                          className="permissoes-lista-items"
                          style={{
                            columns:
                              permissao.lista.length > 4 ? "4 auto" : null,
                          }}
                        >
                          {permissao &&
                            permissao.lista.map((item, index) => (
                              <div key={item.id}>
                                <div className="permissao-checkbox-tab">
                                  <FormControlLabel
                                    control={
                                      <CustomCheckbox
                                        checked={item.permissao}
                                        onChange={(e) =>
                                          handleChangePermissoes(
                                            item,
                                            permissao,
                                            e
                                          )
                                        }
                                        name={item.descricao}
                                      />
                                    }
                                    label={item.descricao}
                                  />
                                </div>
                              </div>
                            ))}
                        </div>
                      </TabPanel>
                    ))}
                </>
              </TabContext>
              {/* <div style={{ display: "flex", flexWrap: "wrap" }}>
                {permissoes &&
                  permissoes.map((permissao, index) => (
                    <div
                      style={{ minWidth: "15%", flexWrap: "wrap" }}
                      key={
                        permissao.lista[index]
                          ? permissao.lista[index].id
                          : index
                      }
                    >
                      <p>{permissao.grupo}</p>

                      <div className="permissoes-lista-items">
                        {permissao &&
                          permissao.lista.map((item, index) => (
                            <div key={item.id}>
                              <div className="permissao-checkbox-tab">
                                <FormControlLabel
                                  control={
                                    <CustomCheckbox
                                      checked={item.permissao}
                                      onChange={(e) =>
                                        handleChangePermissoes(
                                          item,
                                          permissao,
                                          e
                                        )
                                      }
                                      name={item.descricao}
                                    />
                                  }
                                  label={item.descricao}
                                />
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  ))}
              </div> */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "30px",
                }}
              >
                {!guardarLoading ? (
                  <Button className={classes.btnGuardar} type="submit">
                    Guardar
                  </Button>
                ) : (
                  <LoadingButton
                    color="secondary"
                    loading={guardarLoading}
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    variant="contained"
                    type="submit"
                    className={classes.btnGuardar}
                  >
                    Guardar
                  </LoadingButton>
                )}
                {/* <Button
                variant='contained'
                type='submit'
                sx={{ alignSelf: 'right' }}
              >
                Guardar
              </Button> */}
              </div>
            </Paper>
          </form>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner />
        </div>
      )}
    </>
  );
};

export default FormAdd;
